import { css } from 'linaria';
import { Variables } from '../../index';

const disabled = `&[disabled] {
    opacity: 50%;
}`;

const focus = `&:focus-visible {
    box-shadow: 0 0 0 4px ${Variables.css.focusRing};
    outline: none;
}`;

export const states = css`
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        border-radius: ${Variables.css.spacing4};
    }

    [data-theme='light'] &:hover:not([disabled]) & {
        background: rgba(16, 16, 16, 0.04);
    }

    [data-theme='light'] &:active:not([disabled]),
    [data-theme='light'] &:focus-visible:not([disabled]) & {
        background: rgba(16, 16, 16, 0.12);
    }

    [data-theme='dark'] &:hover:not([disabled]) & {
        background: rgba(255, 255, 255, 0.08);
    }

    [data-theme='dark'] &:active:not([disabled]),
    [data-theme='dark'] &:focus-visible:not([disabled]) & {
        background: rgba(255, 255, 255, 0.32);
    }
    ${disabled}
    ${focus}
`;

export const statesSelected = css`
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        border-radius: ${Variables.css.spacing4};
    }

    [data-theme='light'] & {
        background: rgba(16, 16, 16, 0.08);
    }

    [data-theme='light'] &:hover:not([disabled]) & {
        background: rgba(16, 16, 16, 0.04);
    }

    [data-theme='light'] &:active:not([disabled]) & {
        background: rgba(16, 16, 16, 0.12);
    }

    [data-theme='dark'] & {
        background: rgba(255, 255, 255, 0.16);
    }

    [data-theme='dark'] &:hover:not([disabled]) & {
        background: rgba(255, 255, 255, 0.08);
    }

    [data-theme='dark'] &:active:not([disabled]),
    [data-theme='dark'] &:focus-visible:not([disabled]) & {
        background: rgba(255, 255, 255, 0.32);
    }

    ${disabled}
    ${focus}
`;

export const statesSelectedSecondary = css`
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: ${Variables.css.spacing4};
    }

    [data-theme='light'] & {
        background: rgba(255, 85, 0, 0.08);
    }

    [data-theme='light'] &:hover:not([disabled]) & {
        background: rgba(16, 16, 16, 0.04);
    }

    [data-theme='light'] &:active:not([disabled]),
    [data-theme='light'] &:focus-visible:not([disabled]) & {
        background: rgba(16, 16, 16, 0.12);
    }

    [data-theme='dark'] & {
        background: rgba(255, 85, 0, 0.08);
    }

    [data-theme='dark'] &:hover:not([disabled]) & {
        background: rgba(255, 255, 255, 0.08);
    }

    [data-theme='dark'] &:active:not([disabled]),
    [data-theme='dark'] &:focus-visible:not([disabled]) & {
        background: rgba(255, 255, 255, 0.32);
    }

    ${disabled}
    ${focus}
`;
